import { BREEZE_COPILOT, SALES_COPILOT } from 'chatspot-core/types/CopilotAssistantTypes';
import { UNINITIALIZED } from 'chatspot-ui-components/types/RequestStatusType';
const getThreadsByAssistantType = (threads, assistantType) => {
  return threads.filter(thread => thread.assistantType === assistantType) || [];
};
export const getLatestSalesCopilotThreadId = threads => {
  const salesCopilotThreads = getThreadsByAssistantType(threads, SALES_COPILOT).filter(thread => thread.labelStatus !== UNINITIALIZED);
  return salesCopilotThreads && salesCopilotThreads.length > 0 && salesCopilotThreads[0].id;
};

/** Should only be used for Sales Copilot & Interactive Mode */
export const getLatestBreezeCopilotThreadId = (threads, assistantType = BREEZE_COPILOT) => {
  const breezeCopilotThreads = getThreadsByAssistantType(threads, assistantType);
  const breezeCopilotInitializedThreads = breezeCopilotThreads.filter(thread => thread.labelStatus === 'INITIALIZED');
  /** We will first try and find the latest initialized thread,
   * if there are none, we will use an empty thread to avoid creating a new one
   */
  return breezeCopilotInitializedThreads && breezeCopilotInitializedThreads.length > 0 ? breezeCopilotInitializedThreads[0].id : breezeCopilotThreads && breezeCopilotThreads.length > 0 && breezeCopilotThreads[0].id;
};
const getThreadsByAssistantId = (threads, assistantId) => {
  return threads.filter(thread => thread.customCopilotId === assistantId);
};
export const getLatestChatAgentOrBreezeCopilotThreadId = (threads, customCopilotId) => {
  if (!customCopilotId) {
    // Filter out threads that customCopilotId is truthy
    const breezeCopilotThreads = threads.filter(({
      customCopilotId: threadCustomCopilotId,
      assistantType
    }) => !threadCustomCopilotId && assistantType !== SALES_COPILOT);
    return breezeCopilotThreads && breezeCopilotThreads.length > 0 && breezeCopilotThreads[0].id;
  }
  const chatAgentThreads = getThreadsByAssistantId(threads, customCopilotId);
  return chatAgentThreads && chatAgentThreads.length > 0 && chatAgentThreads[0].id;
};